import VueTypes from "vue-types";


export const ServicesProductItem = VueTypes.shape({
    name: VueTypes.string.isRequired,
    description: VueTypes.string.isRequired,
    link: VueTypes.string.isRequired,
    icon: VueTypes.string.isRequired,
}).isRequired;



export const createServicesProductItem = ({ name, description, icon, link, }) => {
    return {
        name: name,
        description: description,
        icon: icon,
        link: link,
    }
}